import React from 'react';
import Icon from '../../atoms/icon';
import Text from '../../atoms/text';
import { faShare } from '@fortawesome/pro-solid-svg-icons';
import AnchorButton from '../../molecules/button/anchor';
import { useActiveDialogsUpdater } from '../../../contexts/active-dialogs';

/**
 * This action kicks off the
 * push message flow
 */

interface BulkPushMessageActionProps {
  header?: string;
  categoryString?: string;
}

export const BulkPushMessageAction = ({
  header,
  categoryString: triageCategory
}: BulkPushMessageActionProps): JSX.Element => {
  const addDialog = useActiveDialogsUpdater();
  const title = 'Send Push Message';

  const handleClick = (e) => {
    e.stopPropagation();

    addDialog({
      id: `bulkPM${triageCategory.length}`,
      name: 'BulkPM',
      payload: {
        header,
        triageCategory
      }
    });
  };

  return (
    <AnchorButton
      className="justify-right"
      onClick={handleClick}
      variant="minimal"
    >
      <Icon className="mr-2" icon={faShare} title={title} />
      <Text className="text-small" dotted>
        <span role="status">{title}</span>
      </Text>
    </AnchorButton>
  );
};
